import { css, styled } from 'styled-components'

import { SPACE_LARGE_PLUS, SPACE_XXSMALL } from '../global/spacing'

/**
 * This container can be used as a wrapper for a button or several buttons. The container centers
 * the button(s) and adds spacing between them. Optionally, extra top padding can be added as well.
 */
export const ButtonContainer = styled.div<{ $padded?: boolean }>`
  display: flex;
  gap: ${SPACE_XXSMALL};
  ${({ $padded }) =>
    $padded &&
    css`
      padding-top: ${SPACE_LARGE_PLUS};
    `}

  & > * {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
`
